import { createIds } from "./helper"
import { translate } from "./translation"
import { Modal } from "bootstrap"

export interface ConfirmInterface {
  id?: string
  noText?: string
  yesText?: string
  text?: string
  title?: string
}

const defaultOptions = {
  noText: translate("No"),
  yesText: translate("Yes"),
  text: translate("Are you sure?"),
  title: null,
}

const template = (options: ConfirmInterface) => `
    <div
      class="modal"
      tabindex="-1"
      id="${options.id}"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            ${
              options.title
                ? `
                <div
                    class="modal-header"
                >
                    ${options.title}
                </div>
            `
                : ""
            }
          <div class="modal-body">
            ${options.text}
          </div>
          <div class="modal-footer">
             <button
                type="button"
                class="btn btn-secondary btn-ko"
              >${options.noText}</button>
              <button
                type="button"
                class="btn btn-primary btn-ok"
              >${options.yesText}</button>
          </div>
        </div>
      </div>
    </div>
`

export function confirm(options: ConfirmInterface = {}) {
  return new Promise((resolve) => {
    const id = createIds()
    const t = template({ ...defaultOptions, ...options, id })
    $("body").append(t)
    const element = document.getElementById(id)
    const modal = new Modal(element, {
      backdrop: "static",
      keyboard: false,
    })
    const send = (confirmed) => {
      modal.hide()
      element.remove()
      resolve(confirmed)
    }
    element.querySelector(".btn-ok").addEventListener("click", () => {
      send(true)
    })
    element.querySelector(".btn-ko").addEventListener("click", () => {
      send(false)
    })
    modal.show()
  })
}
